export default __webpack_public_path__ + "static/media/weather.f741e78b.JPG";